import React, { useEffect } from "react";
import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Router from "./Routes/Router";
import { faviconUrl } from "./Services/EndPoints";

function App() {
  useEffect(() => {
    const faviconElement = document.getElementById("favicon");
    if (faviconElement) {
      faviconElement.href = faviconUrl;
    }
  }, []);

  return (
    <>
      <Router />
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default App;
